import React from 'react';
import Button from '../Button/Button';
import TextInput from '../FormInputs/TextInput/TextInput';
import createEditKeyDownHandler from '../../utils/editKeyDownHandler';

const EditSeason = ({
  season, seasonOnEdit, setSeasonOnEdit, onUpdate, seasonUpdateErrors, setSeasonUpdateErrors,
}) => {
  const handleCancel = () => {
    setSeasonOnEdit({
      id: null, name: '', start_date: '', end_date: '',
    });
    setSeasonUpdateErrors({ name: '', start_date: '', end_date: '' });
  };

  return (
    {
      ...season,
      isEditing: true,
      name: (
        // Enter submits; Escape cancels — keep this for keyboard accessibility
        <div role="none" className="text-black" onKeyDown={createEditKeyDownHandler(onUpdate, handleCancel)}>
          <TextInput
            name="name"
            value={seasonOnEdit.name}
            setValue={v => { setSeasonOnEdit(prev => ({ ...prev, name: v })); setSeasonUpdateErrors(prev => ({ ...prev, name: '' })); }}
            isValid={!seasonUpdateErrors.name}
          />
        </div>
      ),
      start_date: (
        <div className="">
          <input
            type="date"
            name="startDate"
            className={`block w-full h-8 px-1 py-1 rounded-md mt-0 input-field background-vamos-white text-black border border-solid border-1 ${seasonUpdateErrors.start_date ? 'border-vamos-red focus:border-vamos-red' : 'border-vamos-blue-gray focus:border-vamos-black'} focus:outline-none`}
            defaultValue={seasonOnEdit.start_date?.split('T')[0] || ''}
            onChange={e => { setSeasonOnEdit(prev => ({ ...prev, start_date: e.target.value })); setSeasonUpdateErrors(prev => ({ ...prev, start_date: '' })); }}
            onKeyDown={createEditKeyDownHandler(onUpdate, handleCancel)}
          />
        </div>
      ),
      end_date: (
        <div className="">
          <input
            type="date"
            name="endDate"
            className={`block w-full h-8 px-1 py-1 rounded-md mt-0 input-field background-vamos-white text-black border border-solid border-1 ${seasonUpdateErrors.end_date ? 'border-vamos-red focus:border-vamos-red' : 'border-vamos-blue-gray focus:border-vamos-black'} focus:outline-none`}
            defaultValue={seasonOnEdit.end_date?.split('T')[0] || ''}
            onChange={e => { setSeasonOnEdit(prev => ({ ...prev, end_date: e.target.value })); setSeasonUpdateErrors(prev => ({ ...prev, end_date: '' })); }}
            onKeyDown={createEditKeyDownHandler(onUpdate, handleCancel)}
          />
        </div>
      ),
      action: (
        <div className="flex h-14 items-center space-x-2">
          <Button label="Update" onClick={onUpdate} size="md" />
          <Button
            label="Cancel"
            onClick={handleCancel}
            size="md"
            isCancel
          />
        </div>
      ),
    }
  );
};

export default EditSeason;
